export const GIT_BRANCH = "master"
export const GIT_HASH = "8a193e3617b1080f98eea6724c73c214b922db7b"
export const BUILD_NUM = "23912"
export const THEME_COLOR = "#ef3753"
export const PRIMARY_COLOR = "#ffffff"
export const TERTIARY_COLOR = "#414142"
export const APP_NAME = "Sugar Coated Cupcakes"
export const START_URL = "https://web-order.flipdish.co/client/fd3244/latest/pwa.html"
export const WHITE_LABEL_ID = "3244"
